import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from './components/LoginPage.vue';
import DashboardPage from './views/dashboard/DashboardPage.vue';
import TaskPage from './views/task/TaskPage.vue';
import TaskDetailPage from './views/task/TaskDetailPage.vue';
import ForgotPassword from './components/ForgotPassword.vue';

// Simulate an auth check (replace this with your actual authentication logic)
function isAuthenticated() {
  return !!localStorage.getItem('authToken'); // Check if a token exists in local storage
}

const routes = [
  {
    path: '/',
    name: 'DashboardPage',
    component: DashboardPage,
    meta: { requiresAuth: true, requiresMainLayout: true }, // Uses main layout and requires auth
  },
  {
    path: '/login',
    name: 'loginPage',
    component: LoginPage,
    meta: { requiresMainLayout: false }, // Does not use main layout
  },
  {
    path: '/forgot/password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { requiresMainLayout: false }, // Does not use main layout
  },
  {
    path: '/task',
    name: 'TaskPage',
    component: TaskPage,
    meta: { requiresAuth: true, requiresMainLayout: true }, // Uses main layout and requires auth
  },
  {
    path: '/task/:id',
    name: 'ViewTask',
    component: TaskDetailPage,
    meta: { requiresAuth: true, requiresMainLayout: true }, // Uses main layout and requires auth
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Set up a global before guard
router.beforeEach((to, from, next) => {
  // Check if the route requires authentication
  if (to.meta.requiresAuth && !isAuthenticated()) {
    // Redirect to login page if not authenticated
    next({ name: 'loginPage' });
  } else {
    // Allow the navigation
    next();
  }
});

export default router;
